<template>
  <el-checkbox-group v-model="productLineNo">
    <el-checkbox-button
      v-for="row in list"
      :key="row.productLineNo"
      :label="row.productLineNo">{{ row.productLineName }}</el-checkbox-button>
  </el-checkbox-group>
</template>
<script>
// import _ from 'lodash'
export default {
  name: 'VendorSeriesCheckbox',
  components: {},
  props: {
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    productLineNo: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$store.dispatch('product/getallproductlines', {
        payload: this.option,
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
